import '@PROJECT_ROOT/assets/desktop/js/jquery/plugins/jquery.regex';
import '@PROJECT_ROOT/assets/desktop/js/jquery/plugins/jquery.repeat';
import { preCheck, bindChange, sidebarScroll, guestTypeChange } from '@PROJECT_ROOT/assets/desktop/js/charter/singleReservation';
import '@PROJECT_ROOT/assets/desktop/js/reservation/singleUser';
import '@PROJECT_ROOT/assets/desktop/js/reservation/updateUserProfile';

$(() => {
    $(() => {
        sidebarScroll();
        bindChange();
        $('input[id=ReservationCharterSingleForm_od_visual]').change();
        $('#ReservationCharterSingleForm_user_type_new').click().change();
        $('#refreshCalculation').click(preCheck);
        $('#ReservationCharterSingleForm_g_type').change(guestTypeChange);
        guestTypeChange();
    });
});

window.preCheck = preCheck;
